// extracted by mini-css-extract-plugin
export default {"headerContainer":"AccessSettings_headerContainer__wkJ24","trash":"AccessSettings_trash__O7O-8"};